import { createClient } from '@/shared/api/client'
import { buildUrl } from '@/shared/utils/urls'
import { TargetSystem } from '@/shared/constants'
import type { YieldUpdate } from '@/features/assets/types'
import { format } from 'date-fns/format'
import { validateResponseIsOk } from '@/shared/api/validation'

const client = createClient(buildUrl(TargetSystem.AssetManagement))

export async function updateYield(assetCode: string, data: YieldUpdate) {
  await validateResponseIsOk(
    client.sendPatch(`assets/${assetCode}/yields`, {
      data: {
        ...data,
        expectedEndDate: data.expectedEndDate ? format(data.expectedEndDate, 'yyyy-MM-dd') : undefined,
        actualEndDate: data.actualEndDate ? format(data.actualEndDate, 'yyyy-MM-dd') : undefined,
      }
    })
  )
}
